import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../../../components/UI/Avatar";
import { Loader2, MessageCircle } from "lucide-react";
import { formatRelativeTime } from "../../utils/relativeTime";
import { cn } from "../../../../utils/utils";

/**
 * Card lời mời ĐÃ GỬI — gọn hơn, chỉ avatar + tên + thời gian
 * tương đối + 1 button "Thu hồi lời mời".
 */
const SentInvitationCard = ({
  avatar,
  name,
  badge,
  createdAt,
  onWithdraw,
  onOpenChat,
  pending = false,
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-3 flex flex-col gap-2 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start gap-2.5">
        <Avatar className="h-10 w-10 shrink-0">
          <AvatarImage src={avatar} alt={name} />
          <AvatarFallback>{name?.charAt(0) || "?"}</AvatarFallback>
        </Avatar>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5 min-w-0">
            <div className="font-semibold text-[13px] text-gray-900 truncate">
              {name || "(Không tên)"}
            </div>
            {badge && (
              <span className="px-1.5 py-px text-[10px] font-medium rounded bg-blue-50 text-blue-700 shrink-0">
                {badge}
              </span>
            )}
          </div>
          <div className="text-[12px] text-gray-500 truncate">
            {formatRelativeTime(createdAt)}
          </div>
        </div>
        {onOpenChat && (
          <button
            onClick={onOpenChat}
            className="text-gray-400 hover:text-indigo-600 p-1 rounded transition-colors"
            title="Mở chat"
          >
            <MessageCircle size={14} />
          </button>
        )}
      </div>

      <button
        onClick={onWithdraw}
        disabled={pending}
        className={cn(
          "h-8 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700 text-[12px] font-medium transition-colors inline-flex items-center justify-center gap-1.5",
          pending && "opacity-60 cursor-not-allowed",
        )}
      >
        {pending && <Loader2 size={12} className="animate-spin" />}
        Thu hồi lời mời
      </button>
    </div>
  );
};

export default SentInvitationCard;
